import { render, staticRenderFns } from "./IndustrialSectorsSettings.vue?vue&type=template&id=0d34bdf6&scoped=true&"
import script from "./IndustrialSectorsSettings.vue?vue&type=script&lang=js&"
export * from "./IndustrialSectorsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34bdf6",
  null
  
)

export default component.exports